// src/firebase/firebaseConfig.js
import { initializeApp, getApps, getApp } from "firebase/app";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

let firestoreInstance = null;

/**
 * Lazy-load Firestore only when needed (e.g. in ChecklistPortal)
 * Prevents bundling 600+ KiB of Firestore into the initial critical render path
 */
export async function getFirestoreDb() {
  if (!firestoreInstance) {
    const { getFirestore } = await import("firebase/firestore");
    firestoreInstance = getFirestore(app);
  }
  return firestoreInstance;
}

// Solo activar analytics de forma diferida tras la carga inicial
if (typeof window !== "undefined" && firebaseConfig.projectId && firebaseConfig.apiKey) {
  // Retrasar analytics hasta idle para no bloquear FCP / LCP
  const initAnalytics = () => {
    import("firebase/analytics").then(({ getAnalytics, isSupported }) => {
      isSupported().then((supported) => {
        if (supported) {
          getAnalytics(app);
        }
      }).catch(() => {});
    });
  };

  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(initAnalytics);
  } else {
    setTimeout(initAnalytics, 2500);
  }
}

export default app;
